import moment from 'moment';
export const FOSTableDateCell = (props: any) => {
  const { value } = props;

  if (!value) return <div></div>;

  return <div>{moment(value).format('DD.MM.yyyy')}</div>;
};
